<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <footer class="the-footer flex-wrap justify-center" :class="classes">
    <p>
      <span>Copyright &copy;</span>
      <span>{{ new Date().getFullYear() }}&nbsp;</span>
      <a href="https://alquant.com" target="_blank">Alquant</a>
      <span>, All rights reserved</span>
      <span>
        -
        <router-link :to="{ name: 'compliance_termsofuse' }" target="_blank"
          >Terms of use</router-link
        ></span
      >
      <span>
        -
        <router-link :to="{ name: 'compliance_privacypolicy' }" target="_blank"
          >Privacy policy</router-link
        ></span
      >
      <span v-if="ombudsmanText">
        -
        <router-link :to="{ name: 'compliance_ombudsman' }" target="_blank"
          >Ombudsman</router-link
        ></span
      >
    </p>
  </footer>
</template>

<script>
import config from "@/config/alquant";

export default {
  name: "TheFooter",
  props: {
    classes: {
      type: String,
    },
  },
  computed: {
    ombudsmanText() {
      return config.ombudsmanText;
    },
  },
};
</script>
